import { AppImages, React, variantProvider } from '@/app'
import { Button, Image, Text, View } from '@/components'
import { modal, ModalParams } from '@codeleap/modals'
import { LearnOnboadingModal } from './LearnOnboadingModal'

function Content(props: ModalParams) {
  const { toggle } = props

  function onPress() {
    toggle()
    requestAnimationFrame(() => {
      LearnOnboadingModal.open()
    })
  }

  return (
    <View style={styles.wrapper}>
      <Image source={AppImages.personaCTA} style={styles.image} />

      <View variants={['padding:3', 'gap:2', 'column']}>
        <Text
          variants={['h2', 'textCenter']}
          style={{ lineHeight: '30px' }}
          text="Turn your curiosity into confident action, with lessons tailored to your needs and goals"
        />

        <Button
          text="Start your learning journey"
          debugName="open-onboarding-lesson"
          onPress={onPress}
          style={styles.button}
        />
      </View>
    </View>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    image: {
      borderTopLeftRadius: 32,
      borderTopRightRadius: 32
    },
    wrapper: {
      borderRadius: 32,
      ...theme.presets.column,
      width: 422,
      [theme.media.down('small')]: {
        width: '100%'
      }
    },
    button: {
      height: 48
    }
  }),
  true
)

export const PersonaCTAModal = modal()
  .content(props => <Content {...props} />)
  .props({ variants: ['noPadding', 'centered'], styles: { box: styles.wrapper }, closable: true })
